export default function suffolkReducer(state = [], action) {
  switch (action.type) {
    case "FETCH_SUFFOLK":
      return [].concat.apply([], [...state, action.payload]);
    default:
      return state;
  }
}
